import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
 static targets = ["password", "submitButton"]

 connect() {
   this.passwordTarget.closest('.space-y-2').classList.add('hidden')
   this.submitButtonTarget.innerText = 'Continue'
 }

 async handleSubmit(event) {
   if (this.passwordTarget.closest('.space-y-2').classList.contains('hidden')) {
     event.preventDefault()
     const email = this.element.querySelector('input[type="email"]').value
     try {
       const response = await fetch(`/auth/lookup?email=${encodeURIComponent(email)}`, {
         headers: {
           "Accept": "application/json"
         }
       })

       if (response.ok) {
         const data = await response.json()
        if(data.error){
          alert(data.error)
        }else{
          if(data.passkey){
            const passkeyElement = document.getElementById('passkey')
            if (passkeyElement) {
              passkeyElement.click();
            }
          }else if(data.location) {
            this.startSso(data.location)
          }
        }
       } else {
         this.passwordTarget.closest('.space-y-2').classList.remove('hidden')
         this.passwordTarget.focus();
         this.submitButtonTarget.innerText = 'Sign in'
       }
     } catch (error) {
       console.error("Error checking SSO:", error)
       this.passwordTarget.closest('.space-y-2').classList.remove('hidden')
       this.submitButtonTarget.innerText = 'Sign in'
     }
   }
 }

 // The OmniAuth request phase is POST-only (omniauth-rails_csrf_protection),
 // so submit a CSRF-token form rather than navigating with a GET.
 startSso(url) {
   // Only ever fire one SSO POST, even if the action is triggered twice
   // before navigation completes.
   if (this.ssoStarted) return
   this.ssoStarted = true

   const token = document.querySelector('meta[name="csrf-token"]')?.content
   if (!token) {
     // A tokenless POST would be rejected with an opaque 422 — fail loudly
     // here instead of submitting a doomed form.
     this.ssoStarted = false
     alert("Sign-in could not be started. Please reload the page and try again.")
     throw new Error("csrf-token meta tag missing; cannot start SSO")
   }

   const form = document.createElement("form")
   form.method = "POST"
   form.action = url

   const input = document.createElement("input")
   input.type = "hidden"
   input.name = "authenticity_token"
   input.value = token
   form.appendChild(input)

   document.body.appendChild(form)
   form.submit()
 }
}